Vue.asyncComponent('cms-list', {
    props: {
        bundle: {
            type: String,
            required: false
        },
        listDefinition: {
            type: String,
            required: false
        },
    },
    computed: {
        activeBundle() {
            return this.bundle ? this.bundle : this.$route.params.bundle;
        },
        activeListDefinition() {
            return this.listDefinition ? this.listDefinition : this.$route.params.listDefinition;
        },
        forceDark() {
            // for now we force the list to dark mode if we are handeling media
            return this.activeBundle === 'media';
        }
    },
    methods: {
        goToForm(data) {
            this.$router.push({ name: 'list-form' , params: {
                    bundle: data.bundleId,
                    definition: data.definitionId,
                    objectId: data.objectId,
                }});
        },
        goToGrid(data) {
            this.$router.push({ name: 'grid' , params: {
                    bundle: data.bundleId,
                    listDefinition: data.definitionId,
                }});
        }
    }
}, 'cms/pages/cms-list.html');